// @generated
// This file is automatically generated by Kanel. Do not modify manually.

/** Represents the enum public.notebook_sequencing_type */
enum NotebookSequencingType {
  bulk = 'bulk',
  singleCell = 'singleCell',
};

export default NotebookSequencingType;
